import gql from 'graphql-tag';

export default () => gql`
  query {
    getFieldLabels(dummy: "") {
      scope
      field
      optionValue
      language
      label
    }
  }
`;
